import React from "react";
import Storylist from "../StorylistParentToChild";
import { observer } from "mobx-react";
import Book from "../../models/Book";

const lists = {
  papa: [
    ["a", "f", "g", "h"],
    ["i", "j", "k", "l", "m", "n", "o"],
    ["p", "q", "r", "s", "t", "u", "v", "w"]
  ],
  mama: [
    ["a", "e", "f", "g"],
    ["h", "i", "j", "k", "l", "m", "n", "o"],
    ["p", "q", "r", "s", "t", "u", "v", "w"]
  ]
};

class StorySelection extends React.Component {
  constructor() {
    super();
    this.state = {
      book: Book.create({})
    };
  }

  getlist0(list, artistName, book) {
    const isSingle = book.parentToChild.isSingle === "1";
    const grandParentState = book.parentToChild.grandParentState;

    // TODO: 判定は作者に依存している。増えたときに考慮必要かも
    if (artistName === "nakagawa") {
      // 配偶者が有か
      list = !isSingle ? list.concat(["c", "d", "e"]) : list;
    } else {
      // 配偶者が有か
      list = !isSingle ? list.concat(["c", "d"]) : list;
    }

    // 祖父母が両方いないか
    list = grandParentState !== "3" ? list.concat(["b"]) : list;
    // ソートしとく
    list = list.sort();
    return list;
  }

  save = () => {
    this.props.order.saveStories();
  }

  render() {
    const { artistName, book, order, setpImage } = this.props;
    // TODO: 判定は作者に依存している。増えたときに考慮必要かも
    const list = artistName === "nakagawa" ? lists.papa : lists.mama;

    return (
      <div className="story-selection pd-15">
        <img
          style={{
            padding: "16px 0px 38px",
            width: "100%",
            height: "auto"
          }}
          src={require(`../../imgs/${setpImage}`)}
        />

        <div className="step">
          <span className="step-title-alt">{"STEP 1 "}</span>
          <span className="step-txt">{"次の選択文の中から1つを選択（P10 - P13に該当）"}</span>
          <Storylist
            artistName={artistName}
            book={book}
            disabled={book.parentToChild.stories.map(v => v.substring(0, 1))}
            list={this.getlist0(list[0], artistName, book)}
            onSelect={selected => book.parentToChild.setStory(0, selected)}
            selected={book.parentToChild.stories[0].substring(0, 1)}
            storyNumber={1}
          />
        </div>

        <div className="step step-2">
          <span className="step-title-alt">{"STEP 2 "}</span>
          <span className="step-txt">{"次の選択文の中から1つを選択（P14 - P17に該当）"}</span>
          <Storylist
            artistName={artistName}
            book={book}
            disabled={book.parentToChild.stories.map(v => v.substring(0, 1))}
            list={this.getlist0(list[0], artistName, book).concat(list[1]).sort()}
            onSelect={selected => book.parentToChild.setStory(1, selected)}
            selected={book.parentToChild.stories[1].substring(0, 1)}
            storyNumber={2}
          />
        </div>

        <div className="step step-2">
          <span className="step-title-alt">{"STEP 3 "}</span>
          <span className="step-txt">{"次の選択文の中から1つを選択（P18 - P21に該当）"}</span>
          <Storylist
            artistName={artistName}
            book={book}
            disabled={book.parentToChild.stories.map(v => v.substring(0, 1))}
            list={list[1]}
            onSelect={selected => book.parentToChild.setStory(2, selected)}
            selected={book.parentToChild.stories[2].substring(0, 1)}
            storyNumber={3}
          />
        </div>

        <div className="step step-2">
          <span className="step-title-alt">{"STEP 4 "}</span>
          <span className="step-txt">{"次の選択文の中から1つを選択（P22 - P25に該当）"}</span>
          <Storylist
            artistName={artistName}
            book={book}
            disabled={book.parentToChild.stories.map(v => v.substring(0, 1))}
            list={list[1].concat(list[2]).sort()}
            onSelect={selected => book.parentToChild.setStory(3, selected)}
            selected={book.parentToChild.stories[3].substring(0, 1)}
            storyNumber={4}
          />
        </div>

        <div className="step step-2">
          <span className="step-title-alt">{"STEP 5 "}</span>
          <span className="step-txt">{"次の選択文の中から1つを選択（P26 - P29に該当）"}</span>
          <Storylist
            artistName={artistName}
            book={book}
            disabled={book.parentToChild.stories.map(v => v.substring(0, 1))}
            list={list[2]}
            onSelect={selected => book.parentToChild.setStory(4, selected)}
            selected={book.parentToChild.stories[4].substring(0, 1)}
            storyNumber={5}
          />
        </div>

        <div
          style={{
            "paddingTop": "16px",
          }}
          className="btn-wrap"
        >
          <button
            disabled={book.parentToChild.stories.indexOf("") !== -1}
            onClick={this.save}
            className="btn product-btn"
          >
            保存して次へ
            <img
              src="https://cdn.shopify.com/s/files/1/0012/2568/7076/files/arrow-right-purple.png?13701503969354364487"
              className="btn-arrow"
            />
          </button>
        </div>
      </div>
    );
  }
}

export default observer(StorySelection);



// WEBPACK FOOTER //
// ./src/components/steps/StorySelectionParentToChild.js